/**
 * Author : zhengyanfeng.
 * Date   : 2021/1/5.
 * File   : province. 城市id对象
 */
export default {
  '330304': {
    position: {
      left: '910px',
      top: '450px'
    },
    background: require('../../mapPicture/zhejiang/wenzhou/ouhai.png'),
    diningList: [
      {
        departmentName: '教职工食堂',
        departmentId: 'DE17518505BE649BC8451826F40FAF9CC',
        position: {
          left: '50px',
          top: '20px'
        },
        active: '01'
      }
    ]
  }
}



//////////////////
// WEBPACK FOOTER
// ./static/mapPoint/diningPoint/zhejiang/wenzhou.js
// module id = null
// module chunks = 